<template>
  <section class="page-container">
    <div class="flex-sb-center">
      <h1>汽车免赔额补偿保险</h1>
      <v-button
        green
        @click="handleAddEnquiry">新增</v-button>
    </div>
    <div
      class="filter-top">
      <div class="form-item">
        <v-input
          v-model="search"
          :prefixIcon="'el-icon-search'"
          placeholder="名称 / 电话号码 / 车牌号码 / 身份证号码 / 商业登记证号码 / 证书号码"
          @keyEnter="searchData" />
      </div>
    </div>
    <div
      class="filter-container border-bottom-radius">
      <div class="filter-left">
        <div class="form-item">
          <span>创建日期</span>
          <v-date-picker
            v-model="date"
            type="daterange"
            @change="filterData" />
        </div>
        <div class="form-item">
          <span>生效日期</span>
          <v-date-picker
            v-model="effective_date"
            type="daterange"
            @change="filterData" />
        </div>
      </div>
      <div class="filter-middler">
        <div
          class="filter-box status-button">
          <div class="filter-box-text">
            <span>状态</span>
          </div>
          <div class="flex">
            <v-checkbox-group
              v-model="stts"
              :borderBlock="true"
              block
              :list="globalOptions.stts"
              @change="searchData" >
              <template #default="{ item }">
                <span class="flex">
                  <span
                    class="span-status"
                    :class="{
                      'yellow-dark': [1].includes(item.id),
                      'yellow': [4].includes(item.id),
                      'red': [0].includes(item.id),
                      'green': [3].includes(item.id),
                      'blue': [2].includes(item.id),
                    }">{{ item['name'] }}</span>
                </span>
              </template>
            </v-checkbox-group>
          </div>
        </div>
      </div>
      <div class="filter-middler">
        <div class="form-item">
          <span>保险计划</span>
          <v-select
            v-model="plan_id"
            :list="globalOptions.plans"
            clearable
            @change="filterData" />
        </div>
      </div>
    </div>
    <div
      class="transparent">
      <list-table
        :tableData="tableData"
        is-enquiry
        @rowClick="rowClick"
      ></list-table>
    </div>

    <v-pagination
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      @currentChange="currentChange" />
  </section>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import ListTable from './components/list-table.vue'
import {
  getOrderList
} from '@/api/order'
import MixinOptions from '@/mixins/options'

export default {
  name: 'List',
  components: {
    ListTable,
  },
  mixins: [MixinOptions],
  data() {
    return {
      addEnquiry:false,
      pageConfig: {
        //  分頁配置
        currentPage: 1,
        total: 10
      },
      tableData:[],
      stts:[],
      plan_id:'',
      search:'',
      date:'',
      effective_date:'',
      filter:{
        stts:[],
        plan_id:'',
        search:''
      }
    }
  },
  computed: {
    ...mapState('common', ['globalOptions']),
  },
  watch: {
    property: {
      immediate: true,
      handler() {
        let {order={}} =  this.selectFilterData||{}
        Object.keys(order).forEach(item=>{
          this[item] = order[item]
        })
        this.setFilterData(order||{})
        this.pageConfig.currentPage = 1
        this.handler().handlerGetData()
      }
    }
  },
  methods: {
    ...mapActions('filter', ['setFilterData','setOpenFilterCar']),
    filterData(){
      this.searchData()
    },
    handleAddEnquiry(){
      this.$router.push('/certificates/create')
    },
    rowClick(row) {
      let params = {
        search: this.search,
        created_start: this.date[0],
        pcy_cmnt_start: this.effective_date[0],
        created_end:this.date[1],
        pcy_cmnt_end: this.effective_date[1],
        plan_id:this.plan_id,
        stts:this.stts,
      }
      this.$router.push({
        path: '/certificates/detail',
        query: {
          id: row.order_id
        }
      })
    },
    searchData() {
      this.pageConfig.currentPage = 1
      this.handler().handlerGetData()
    },
    currentChange(page) {
      this.pageConfig.currentPage = page
      this.handler().handlerGetData()
    },
    handler() {
      return {
        handlerGetData: () => {
          this.network().getOrderList()
        }
      }
    },
    network() {
      return {
        getOrderList: async () => {
          const { data } = await getOrderList({
            search: this.search,
            created_start: this.date[0],
            pcy_cmnt_start: this.effective_date[0],
            created_end:this.date[1],
            pcy_cmnt_end: this.effective_date[1],
            plan_id:this.plan_id,
            stts:this.stts,
          })
          this.tableData = data.data
          this.pageConfig.total = data.total
        },
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  position: relative;
  color: #303133;
  h1{
    font-family: inter;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 36px;
    letter-spacing: 0.3px;
    color: #24292E;
    margin-bottom: 15px;
  }
  .hide-selection {
    width: 100%;
    /deep/ tr {
      td:first-child, th:first-child {
        display: none;
      }
    }

  }

  .blue-circle {
    position: relative;
    display: inline-block;
    margin-right: 5px;
    width: 8px;
    height: 8px;
    border-radius: 100%;
    cursor: pointer;
    position: absolute;
    left: -5px;
    &.blue{
      background: #409EFF;
    }
    &.yellow-circle{
      background: #DBAB09!important;
    }
    &::after {
      content: '';
      position: absolute;
      top: -5px;
      left: -5px;
      right: -5px;
      bottom: -5px;
    }
  }
  .btn-top-container {
    position: absolute;
    top: 10px;
    right: 0;
  }
  .text-right {
    display: flex;
    justify-content: flex-end;
    .el-input {
      margin-left: 10px;
      width: 250px;
    }
    .el-button{
      height: 32px;
      margin-left: 0;
      margin-right: 15px;
    }
    .button-blue{
      font-family: Inter;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: -0.15px;
      color: #0366D6;
    }
    .filter-select{
      margin-left: 0;
      margin-right: 15px;
    }
  }
  .filter-top{
    margin-bottom: 14px;
  }
  .filter-flex {
    margin-top: 10px;
    .form-item:first-child {
      margin-right: 15px;
      width: 400px;
    }
    .form-item:last-child {
      width: 400px;
    }
  }
  .filter-select {
    margin-left: 10px;
    width: 175px;
  }

  .transparent {
    margin-top: 15px;
  }
  .filter-container {
    margin-bottom: 30px;
    background: white;
    border: 1px solid #D1D5DA;
    border-radius: 5px;
    display: flex;
    .filter-left, .filter-middler, .filter-right, .filter-last {
      padding: 15px 0;
    }
    .filter-left {
      width: 290px;
      padding: 15px;
    }
    .left-border{
      border-left: 1px solid #E1E4E8;
    }
    .filter-middler {
      padding: 15px 10px;
      border-left: 1px solid #E1E4E8;
      //border-right: 1px solid #E1E4E8;
      width: 300px;
    }
    .filter-right {
      padding: 15px 10px;
      flex: 1;
    }
    .filter-box-text{
      display: flex;
      margin-bottom: 12px;
      /*justify-content: space-between;*/
      margin-right: 20px;
      span{
        margin-right: 10px;
        font-family: Inter;
        font-size: 14px;
        letter-spacing: 0;
        line-height: 17px;
      }
      span:first-child{
        color: #24292E;
        font-weight: 600;

      }
      .flex{
        span{
          color: #0366D6;
          cursor: pointer;
        }
      }
    }
    .all {
      display: inline-block;
      padding-left: 15px;
      color: #409eff;
      cursor: pointer;
      font-weight: 600;
    }
    .flex-wrap{
      flex-wrap: wrap !important;
    }
    & > span:first-child {
      font-size: 12px;
      font-weight: bold;
    }


    .input-container {
      max-width: 360px;
    }
    .button-right {
      // position: absolute;
      // right: 0;
      margin-left: 20px;
    }

    .filter-box {
      margin-right: 20px;
      .span-status {
        display: flex;
        align-items: center;
        /deep/ .el-checkbox__label {
          margin-left: 10px;
          padding: 0 10px;
          font-size: 12px;
          border: 1px solid #b08800;
          color: #b08800;
          background: white;
          border-radius: 50px;
          line-height: 20px;
          white-space: nowrap;
        }
      }
      .upload-status {
        display: flex;
        align-items: center;
        /deep/ .el-checkbox__label {
          margin-left: 10px;
          padding: 0 10px;
          font-size: 12px;
          border: 1px solid #0366D6;
          color: #0366D6;
          background: white;
          border-radius: 50px;
          line-height: 20px;
          white-space: nowrap;
        }
      }
    }
    .type-button {
      // margin-right: 20px;
      margin-top:20px;
      ::v-deep .el-radio {
        //margin-right: 20px!important;
        //.min-width: 138px;
        margin-right: 23px;
        .el-radio__label {
          display: inline-block;
          padding: 0px 10px;
          height: auto;
          //line-height: 30px;
          font-size: 12px;
          border-radius: 50px;
          border: 1px solid #E1E4E8;
          color: #24292E;
          background: white;
          font-weight: 500;
          letter-spacing: 0;
          line-height: 18px;
          margin-left:8px ;
          margin-right: 23px;
        }
        &:first-child{
          .el-radio__label {
            border: 0px;
          }
        }
      }
    }
    .status-button {
      // margin-right: 20px;
      /*margin-top:20px;*/
      .span-status{
        display: inline-block;
        padding: 0px 10px;
        height: auto;
        //line-height: 30px;
        font-size: 12px;
        border-radius: 50px;
        border: 1px solid #E1E4E8;
        color: #24292E;
        background: white!important;
        font-weight: 500;
        letter-spacing: 0;
        line-height: 18px;
        &.yellow-dark{
          border: 1px solid #735C0F;
          color: #735C0F;
        }
        &.yellow{
          border: 1px solid #DBAB09;
          color: #DBAB09;
        }
        &.blue{
          border: 1px solid #0366D6;
          color: #0366D6;
        }
        &.green{
          border: 1px solid #22863A;
          color: #22863A;
        }

        &.red{
          border: 1px solid #D73A49;
          color: #D73A49;
        }
      }
    }

    .snooze-filter {
      // margin-right: 20px;
      /*margin-top:20px;*/
      ::v-deep .el-checkbox-group {
        .el-checkbox {
          margin-right: 20px;
          .el-checkbox__label {
            padding: 0;
            span {
              display: flex;
              display: inline-block;
              //padding: 0px 10px;
              height: auto;
              //line-height: 30px;
              font-size: 14px;
              /*border-radius: 50px;*/
              border:none;
              color: #24292E;
              background: white;
              font-weight: 600;
              letter-spacing: 0;
              line-height: 18px;
            }
          }
        }
      }
    }

    //.el-checkbox-group {
    //  display: flex;
    //  flex-wrap: nowrap;
    //}
  }
  .flex-checkout{
    display: flex;
    margin-top: 11px;
    .el-checkbox-group {
      display: flex;
      flex-direction: column;
      flex-wrap: nowrap;
      align-items: flex-start;
    }
    .flex{
      align-items: center;
    }
  }
  .circle {
    display: inline-block;
    margin-right: 5px;
    width: 14px;
    height: 14px;
    min-width: 14px;
    min-height: 14px;
    border-radius: 100%;
    &.orange-light {
      background: #E36209;
    }
    &.yellow-dark {
      background: #DBAB09;
    }
    &.blue {
      background: #0366D6;
    }
    &.green {
      background: #28A745;
    }
    &.red {
      background: #D73A49;
    }
    &.purple {
      background: #6F42C1;
    }
  }

  ::v-deep .tableHeader {
    margin-top: 30px;
    background: #F6F8FA !important;
    height: 45px;
    th {
      background-color:#F6F8FA !important;
      font-family: Inter;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      letter-spacing: -0.15px;
      color: #24292E;
      height: 45px;
      .cell{
        height: 30px;
      }
    }
  }
  .span-status {
    /*display: block;*/
    margin-right: 5px;
    padding: 0 8px;
    //height:  20px;
    //line-height: 20px;
    border-radius: 25px;
    white-space: nowrap;

    height: 18px;
    //font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    color: #24292E;
    &.success {
      color:  rgb(67, 181, 92);
      background: rgb(220, 255, 228);
    }
    &.warning {
      background: rgb(255, 245, 177);
      color: rgb(218, 193, 93);
    }
    &.error {
      background: rgb(215, 58, 73);
      color: white;
    }
    &.warning-plain {
      border: 1px solid #B08800;
      color: #B08800;
    }
    &.unread-uplod {
      border: 1px solid #0366D6;
      color: #0366D6;
    }
    &.type-status{
      border: 1px solid #E1E4E8;
      color: #24292E;
    }
  }
  .status-height{
    height: 18px;
    line-height: 18px;
    padding: 0px 10px;
  }
  .status-two{
    border: 1px solid #0366D6;
    color: #0366D6;
    display: inline-block;
    padding: 0px 8px;
    font-size: 12px;
    border-radius: 50px;
    height: 18px;
    line-height: 18px;
    //font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
  }
  .status-one{
    border: 1px solid #735C0F;
    color: #735C0F;
    display: inline-block;
    padding: 0px 8px;
    font-size: 12px;
    border-radius: 50px;
    height: 18px;
    line-height: 18px;
    //font-family: Inter;
    font-style: normal;
    font-weight: 600;
  }
  .status-three
  {
    border: 1px solid #22863A;
    color: #22863A;
    display: inline-block;
    padding: 0px 8px;
    font-size: 12px;
    border-radius: 50px;
    height: 18px;
    line-height: 18px;
    //font-family: Inter;
    font-style: normal;
    font-weight: 600;
  }
  .span-status-stts{
    //font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    /* identical to box height, or 150% */
    display: inline-block;
    color: #FFFFFF;
    padding: 0px 8px;
    height: 18px;

    //background: #E36209;
    border-radius: 100px;
    &.orange-light {
      background: #E36209;
    }
    &.yellow-dark {
      background: #DBAB09;
    }
    &.blue {
      background: #0366D6;
    }
    &.green {
      background: #28A745;
    }
    &.red {
      background: #D73A49;
    }
    &.purple {
      background: #6F42C1;
    }

  }
  .flex-aglin{
    display: flex;
    flex-direction: column;
    justify-content:space-between ;
    p{
      height: 24px;
    }
    p:first-child{
      color: #24292E;
      font-size: 14px;
      font-weight: 600;
    }
  }
  .liter-text{
    color: #6A737D;
    font-family: Inter;
    font-size: 12px;
    letter-spacing: 0;
    line-height: 18px;
    height: 18px;
  }

  .text-right{
    position: absolute;
    z-index: 100;
    right: 1px;
    margin-top: 6px;
    //margin-right: 15px;
    height: 40px;
    width: 90%;
    background-color:#F6F8FA !important;
  }
}
.el-table{
  border-radius: 4px;
  border:1px solid #D1D5DA;
  ::v-deep .flex-algin{
    //display: flex;
    //flex-direction: column;
    //justify-content:space-between ;
    p,span{
      height: 24px;
    }
    .flex-circle{
      height: 24px;
      align-items: center;
      span{
        color: #24292E;
        font-size: 14px;
        font-weight: 600;
      }
    }
    p:first-child{
      color: #24292E;
      font-size: 14px;
      font-weight: 600;
      span{
        font-weight: 600;
      }
    }
  }
  .liter-time{
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    color: #24292E;
  }
  .liter-text{
    color: #6A737D;
    font-family: Inter;
    font-size: 12px;
    letter-spacing: 0;
    line-height: 15px;
  }
  .text-span{
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    color: #24292E;
  }
  ::v-deep .el-table-column--selection{
    .cell{
      padding-left: 15px!important;
    }
  }
  ::v-deep td{
    padding: 10px 0!important;
    vertical-align: top;
  }
  ::v-deep .el-checkbox:last-of-type{
    margin-top: 4px;
  }
}
.showLick{
  color:  #000;
  text-decoration: none;
  &:hover{
    color:  #0366D6;
  }
}
</style>
